import { z } from 'zod'

export const CottageBookmarksSchema = z
  .array(
    z.object({
      value: z.boolean(),
      label: z.string(),
      id: z.number().int(),
    }),
  )
  .refine(items => {
    const trueValueItems = items.filter(item => item.value)
    return trueValueItems.length > 0
  })

export type CottageBookmarks = z.infer<typeof CottageBookmarksSchema>
